import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ForInvestorsSection extends ContentItem {
  constructor() {
    super({
        opertyResolver: fieldName => `_${fieldName}`
    });
  }
  get sectionName() {
    return get(this, 'name.value', '');
  }
  get linkedFiles() {
    return get(this, 'linked_files', '');
  }


}



// WEBPACK FOOTER //
// ./src/models/ForInvestorsSection.model.js